import React from "react";

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: keyof JSX.IntrinsicElements;
  width?: "default" | "prose" | "wide";
}

export function Container({
  as: Tag = "div",
  width = "default",
  className = "",
  children,
  ...rest
}: ContainerProps) {
  const widthClass =
    width === "prose"
      ? "max-w-prose"
      : width === "wide"
      ? "max-w-[1440px]"
      : "max-w-container";

  const cls = `${widthClass} mx-auto px-6 sm:px-8 lg:px-12 ${className}`.trim();

  return React.createElement(Tag, { className: cls, ...rest }, children);
}

export default Container;
